module.exports = __webpack_public_path__ + "static/img/A151.ccf16041.jpg";